import createDragViewState from 'owa-dnd/lib/utils/createDragViewState';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import getSelectedFolderViewState from './getSelectedFolderViewState';
import TodoListItemViewState from '../store/schema/TodoListItemViewState';
import { setTodoListItemViewState } from '../actions/todoFolderViewStateActions';

export default function getTodoItemViewState(itemId: string): TodoListItemViewState {
    const folderViewState = getSelectedFolderViewState();
    let todoViewState = folderViewState.todoItemViewStates.get(itemId);

    if (!todoViewState) {
        todoViewState = {
            drag: createDragViewState(),
            drop: createDropViewState(),
        };

        setTodoListItemViewState(itemId, todoViewState);
    }

    return todoViewState;
}
